module.exports = __webpack_public_path__ + "img/tlh.400b95e2.png";